module.exports = __webpack_public_path__ + "static/banking-210bf9afc4a40ec022a850dcac0912a1.jpg";